<div class="row">
        <div class="col-3">
        <app-control label='Approval Date' type="datetime" [isDisabled]="true" [(ngModel)]="model.approvalDate"/>                             
    </div>

    <div class="col-3">
        <app-control label="Approved By" type="string" [isDisabled]="true" [ngModel]="approvedByFullName"/>                                
    </div>

    <div class="col-3">
        <app-control label='Rejection Date' type="datetime" [isDisabled]="true" [(ngModel)]="model.rejectionDate"/>                             
    </div>

    <div class="col-3">
        <app-control label="Rejected By" type="string" [isDisabled]="true" [ngModel]="rejectedByFullName"/>                                
    </div>
</div>

<div class="row">
    <div class="col-12">
        <app-control label="Rejection Remark" type="string" [(ngModel)]="model.rejectionRemark" isDisabled="true"/>                                
    </div>
</div>